import { SelectedField, FormConfig, CATEGORY_LABEL_MAP, CATEGORY_ORDER } from "./IntakeFormAIModal.types";

export interface FieldSection {
  categoryKey: string;
  label: string;
  fields: SelectedField[];
}

export const groupFieldsByCategory = (fields: SelectedField[]): FieldSection[] => {
  const groups = new Map<string, SelectedField[]>();
  for (const field of fields) {
    const key = field.category ?? "OTHER";
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(field);
  }

  const knownKeys = new Set(CATEGORY_ORDER);
  const ordered: FieldSection[] = CATEGORY_ORDER
    .filter((key) => groups.has(key))
    .map((key) => ({ categoryKey: key, label: CATEGORY_LABEL_MAP[key] ?? key, fields: groups.get(key)! }));

  for (const [key, sectionFields] of groups) {
    if (!knownKeys.has(key)) {
      ordered.push({ categoryKey: key, label: CATEGORY_LABEL_MAP[key] ?? key, fields: sectionFields });
    }
  }

  return ordered;
};

export const deduplicateFieldsById = (fields: SelectedField[]): SelectedField[] => {
  const seen = new Set<number>();
  return fields.filter((f) => {
    if (seen.has(f.id)) return false;
    seen.add(f.id);
    return true;
  });
};

export const filterFieldsByQuery = (
  fields: SelectedField[],
  query: string
): SelectedField[] =>
  fields.filter((f) =>
    f.label.toLowerCase().includes(query.toLowerCase())
  );

export const areAllSelected = (
  fields: SelectedField[],
  selectedIds: Set<number>
): boolean =>
  fields.length > 0 && fields.every((f) => selectedIds.has(f.id));

export const isFormConfigValid = (
  config: FormConfig,
  selectedIds: Set<number>,
  hasAttachment: boolean = false
): boolean =>
  config.formName.trim().length > 0 &&
  config.lineOfService !== null &&
  config.formType !== null &&
  (hasAttachment || selectedIds.size > 0);

export const mapToCascadingOptions = (options: any[]) =>
  options.map((opt, index) => ({
    id: opt.id ?? opt.value ?? index,
    code: opt.id ?? opt.code,
    label: opt.label,
    value: opt.value,
  }));
